module.exports = __webpack_public_path__ + "img/Cookie_1_resize_34.0a4646b1.png";